"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
/**
 * Created by jonas on 2024-05-17.
 */
const GuiButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const PromoPanelAssetConfig_1 = require("./config/PromoPanelAssetConfig");
class CloseButton extends GuiButton_1.GuiButton {
    constructor(name, clickCallback) {
        super(name, clickCallback);
        this.init();
    }
    init() {
        this.cross = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.CLOSE));
        this.cross.tint = 0x000000;
        this.cross.pivot.set(Math.floor(this.cross.width * 0.5), Math.floor(this.cross.height * 0.5));
        this.plate = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.CLOSE_BG_ICON));
        this.plate.pivot.set(Math.floor(this.plate.width * 0.5), Math.floor(this.plate.height * 0.5));
        this.addChild(this.plate, this.cross);
    }
    showHidePlate(show) {
        this.plate.alpha = show ? 1 : 0;
    }
}
exports.CloseButton = CloseButton;
//# sourceMappingURL=CloseButton.js.map